import { Tab, Tabs } from 'react-bootstrap';

//components
import withLocalization from '~/hoc/withLocalization';
import VacationSettings from './vacationSettings';
import VacationOthersSettings from './VacationOthersSettings';
import VacationTypes from './vacationTypes';

const VacationSettingTabs = (props) => {
    const { t, handleUserDataChange } = props;

    return (
        <Tabs defaultActiveKey="vacationSettings" id="MainTabContainer">
            <Tab eventKey="vacationSettings" title={t('Vacation Settings')}>
                <VacationSettings
                    handleUserDataChange={handleUserDataChange}
                />
            </Tab>
            <Tab eventKey="vacationTypes" title={t('Vacation Types')}>
                <VacationTypes />
            </Tab>
            <Tab eventKey="others" title={t('Others')}>
                <VacationOthersSettings
                    handleUserDataChange={handleUserDataChange}
                />
            </Tab>
        </Tabs>
    )
}

export default withLocalization(VacationSettingTabs);